export const isApiErrorMessage = <T extends string>(
  message: string,
  translations: { [key in T]: string },
): message is T => {
  return message in translations;
};
